import { UserContext } from "@/components/providers/UserContext/UserContext";
import { useContext } from "react";

// In UserContext.tsx or a separate hooks file
export function useUser() {
  const context = useContext(UserContext);
  // Add a check if you used the 'undefined' approach or want extra safety
  if (context === undefined /* or check if context === defaultValue */) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}
